import Axios from 'axios'
const cancelToken = Axios.CancelToken
export default {
    methodGet: 'GET',
    methodPost: 'POST',
    methodPut: 'PUT',
    methodDelete: 'DELETE',
    cancel: null,
    isValidMethod(method) {
        if(method.toUpperCase() !== this.methodDelete || method.toUpperCase() !== this.methodGet || method.toUpperCase() !== this.methodPost || method.toUpperCase() !== this.methodPut) {
            return false
        }
        return true
    },
    getHeaders (authAPIToken, authAPISignature, authUser, authUserSignature, subDomain, environmentId,  branchId, lang, domain ) {
        return {
            'X-Auth-API-Token': authAPIToken,
            'X-Auth-API-Signature': authAPISignature,
            'X-Auth-User': authUser,
            'X-Auth-User-Signature': authUserSignature,
            'X-SubDomain': subDomain,
            'X-Domain': domain,
            'X-Branch-Id': branchId,
            'X-Environment-Id': environmentId,
            'X-Lang': lang
        }
    },
    getConfigs (authAPIToken, authAPISignature, authUser, authUserSignature, subDomain, environmentId,  branchId, lang, domain) {
        return {
            headers: this.getHeaders(authAPIToken, authAPISignature, authUser, authUserSignature, subDomain, environmentId, branchId, lang, domain),
            'withCredentials': false
        }
    },
    buildJSONParams (args) {
        let params = {}
        if (Array.isArray(args)) {
            for(let arg in args) {
                arg = args[arg]
                params[arg.key] = arg.value
            }
        }
        params = JSON.stringify(params)
        return params
    },
    buildParams (args) {
        let params = ''
        if (typeof args === 'string') {
            params = args
        } else {
            if (Array.isArray(args)) {
                for (let i in args) {
                    let type = Core.Value.typeText
                    if (args[i].type !== undefined) {
                        type = args[i].type
                    }
                    if (params.length === 0) {
                    } else {
                        params += '&'
                    }
                    let arg = args[i]
                    if (undefined !== arg.key) {
                        params += arg.key + '=' + Core.Value.decode(arg.value, arg.type)
                    } else {
                        params += arg
                    }
                }
            }
        }
        return params
    },
    get (api, root, args) {
        let params = ''
        if (args) {
            if (typeof args === 'string') {
                params = '?' + args
            } else {
                params = '?' + this.buildParams(args)
            }
        }
        if (undefined === root) {
            root = ''
        }
        return api + root + params
    },
    request(method, root, args, onSuccess) {
        let me = this

        if (this.cancel !== null) {
            this.cancel()
            this.cancel = null
        }

        let requestConfigs = this.getConfigs(Mantle.Config.api.auth.token,
            Mantle.Config.api.auth.signature, Core.Session.AuthUser.email,
            Core.Session.AuthUser.signature, Core.Session.subDomain,
            Core.Session.environmentId, Core.Session.branchId,
            Core.Session.Setting.getSetting('lang'),
            Core.Session.domain)

        requestConfigs.cancelToken = new cancelToken(function executor(c) {
            me.cancel = c
        })

        let url = Mantle.Config.api.url

        switch(method) {
            case this.methodGet:
                Axios.get(this.get(url, root, args), requestConfigs)
                    .then(function (response) {
                        if (response.data !== undefined) {
                            onSuccess(response.data)
                        }
                    }).catch(function(err){
                })
                break
            case this.methodPost:

                let postParams = this.buildParams(args)
                if (requestConfigs['Content-Type']!==undefined) {
                    switch(requestConfigs['Content-Type']) {
                        case 'application/json':
                            postParams = this.buildJSONParams(args)
                            break
                    }
                }

                Axios.post(this.get(url, root), postParams, requestConfigs)
                    .then(function (response) {
                        if (response.data !== undefined) {
                            onSuccess(response.data)
                        }
                    }).catch(function(err){
                })
                break
            case this.methodPut:

                let putParams = this.buildParams(args)
                if (requestConfigs['Content-Type']!==undefined) {
                    switch(requestConfigs['Content-Type']) {
                        case 'application/json':
                            putParams = this.buildJSONParams(args)
                            break
                    }
                }

                Axios.put(this.get(url, root), putParams, requestConfigs)
                    .then(function (response) {
                        if (response.data !== undefined) {
                            onSuccess(response.data)
                        }
                    }).catch(function(err){
                    me.error(err)
                })
                break
            case this.methodDelete:
                Axios.delete(this.get(url, root, args), requestConfigs)
                    .then(function (response) {
                        onSuccess(response.data)
                    }).catch(function(err){
                })
                break
        }
    },
}